module.exports = {


  footerText: '®2020 Todos los derechos reservados. Desarrollado por Intersistemas, S.A. de C.V.',
  version: 'v2.3.0'

};
